import { NestedProject } from "@habity/types";
import slugify from "slugify";
import { ROUTES } from "@habity/constants";

export const getProjectSlug = (project: NestedProject) => {
  const { id, name } = project;
  if (!id) return "";

  const nameText = name ? slugify(name) : "";

  return slugify(`${nameText}-${id}`);
};

export const getProjectPath = (project: NestedProject) => {
  return ROUTES.PROFILES.PROJECTS + getProjectSlug(project);
};
